import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const DashboardToolbar = ({ 
  searchQuery, 
  onSearchChange, 
  sortBy, 
  onSortChange,
  filterTech,
  onFilterTechChange,
  onNewProject,
  selectedCount,
  onBulkDelete,
  onBulkExport
}) => {
  const sortOptions = [
    { value: 'date-desc', label: 'Newest First' },
    { value: 'date-asc', label: 'Oldest First' },
    { value: 'name-asc', label: 'Name (A-Z)' },
    { value: 'name-desc', label: 'Name (Z-A)' },
    { value: 'size-desc', label: 'Largest First' },
    { value: 'size-asc', label: 'Smallest First' }
  ];

  const techStackOptions = [
    { value: 'all', label: 'All Technologies' },
    { value: 'react', label: 'React' },
    { value: 'vue', label: 'Vue.js' },
    { value: 'angular', label: 'Angular' },
    { value: 'node', label: 'Node.js' },
    { value: 'python', label: 'Python' },
    { value: 'java', label: 'Java' },
    { value: 'dotnet', label: '.NET' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary flex items-center justify-center">
            <Icon name="FolderKanban" size={24} color="#FFFFFF" />
          </div>
          <div>
            <h1 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground">
              My Projects
            </h1>
            <p className="text-sm md:text-base text-muted-foreground">
              Manage and access your generated applications
            </p>
          </div>
        </div>
        <Button
          variant="default"
          size="default"
          iconName="Plus"
          iconPosition="left"
          onClick={onNewProject}
        >
          New Project
        </Button>
      </div>
      {selectedCount > 0 && (
        <div className="mb-4 p-3 bg-primary/10 border border-primary/20 rounded-lg flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 animate-fade-in">
          <div className="flex items-center gap-2">
            <Icon name="CheckSquare" size={20} className="text-primary" />
            <span className="text-sm font-medium">
              {selectedCount} project{selectedCount > 1 ? 's' : ''} selected
            </span>
          </div>
          <div className="flex gap-2 w-full sm:w-auto">
            <Button
              variant="outline"
              size="sm"
              iconName="Download"
              iconPosition="left"
              onClick={onBulkExport}
              className="flex-1 sm:flex-none"
            >
              Export
            </Button>
            <Button
              variant="destructive"
              size="sm"
              iconName="Trash2"
              iconPosition="left"
              onClick={onBulkDelete}
              className="flex-1 sm:flex-none"
            >
              Delete
            </Button>
          </div>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
        <div className="lg:col-span-2">
          <Input
            type="search"
            placeholder="Search projects by name or prompt..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>
        <Select
          placeholder="Sort by"
          options={sortOptions}
          value={sortBy}
          onChange={onSortChange}
        />
        <Select
          placeholder="Filter by technology"
          options={techStackOptions}
          value={filterTech}
          onChange={onFilterTechChange}
          className="md:col-span-2 lg:col-span-1"
        />
      </div>
    </div>
  );
};

export default DashboardToolbar;